import { RegulationModel } from 'src/app/core/models/regulation';

export class RegulationDetailModel {
    regulation: RegulationModel;
    screenUrl: string;

    constructor() {
        this.screenUrl = '';
        this.regulation = new RegulationModel();
    }
}
